(function($, undefined) {
	"use strict";
	
	let utils;
	let formValidator;
	let locationsUtils;

	function init() {
		let form = $('.wizard_step2 .wizard__questions');
		utils = Fw.component.models().utils;
		formValidator = Fw.component.models().form;
		locationsUtils = Fw.component.models().locationsUtils;
		form.on('submit', onFormSubmit);
	}
	
	function onFormSubmit(e) {
		const form = $(e.currentTarget);

		e.preventDefault();

		locationsUtils.hideMessage(form, '');

		formValidator.validateForm(form)
		locationsUtils.addOverlay();

		if (!form.hasClass('has-error')) {
			const info = { information: locationsUtils.parseInfo() };
			$('[name="field3"]').val(JSON.stringify(info));
			let images = $('[name="resources"]').get(0).files;

			utils.uploadSecureFiles(images, (json) => {
				if (json && json.hasOwnProperty('media') && json.media.hasOwnProperty('mediaIds')) {
					let mediaId = json.media.mediaIds[0].split(" - ")[0];
					$('[name="field20"]').val(mediaId);
				}
				form.get(0).submit();
			}, null, "image", utils.UPLOAD_KEY);
		} else {
			locationsUtils.removeOverlay();
		}
	}

	$(init);
	
})(jQuery);